import { useContext } from 'react';

import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { AlertSnackbarContext } from '../../../components/snackbars';
import { Media } from '../../../types/Media';
import Api from '../../api/api';

export type AdvertisementUpdateDTO = {
  title: string;
  published: boolean;
  media: Media;
};

export const updateAdvertisement = async ({ id, params }: { id: string; params: AdvertisementUpdateDTO }) => {
  const [response, bodyOrError] = await Api.patch(`advertisement/${id}`, params);

  if (!response.ok) {
    throw bodyOrError;
  }
  return bodyOrError;
};

export const useUpdateAdvertisement = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [, setAlertSnackbar] = useContext(AlertSnackbarContext);

  return useMutation('updateAdvertisement', updateAdvertisement, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(['getAdvertisementsByPage']);
      queryClient.invalidateQueries(['getAdvertisement']);
      setAlertSnackbar({
        message: `${data.title} updated successfully.`,
        severity: 'success',
        vertical: 'top',
      });
      navigate('/cms/advertisements');
    },
  });
};
